(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["es-free-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('es-cart-add')) {
    class EsCartAdd extends HTMLElement {
      static pending = false;

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelector('button').addEventListener('click', () => this.add());
      }

      async add() {
        const button = this.querySelector('button');
        if (EsCartAdd.pending || button.disabled) return;
        EsCartAdd.pending = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const label = button.textContent;
        button.textContent = this.dataset.loading;
        const status = this.querySelector('[role="status"]');
        status.hidden = true;
        const root = window.Shopify.routes.root;
        const drawer = this.closest('cart-drawer');
        const pageItems = document.querySelector('cart-items');
        const pageSections = pageItems ? pageItems.getSectionsToRender() : [];
        const sectionIds = [...new Set(['cart-drawer', 'cart-icon-bubble', ...pageSections.map(s => s.section)])];
        let rejected = false;
        let accepted = false;
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: this.dataset.variantId, quantity: 1 }],
              sections: sectionIds,
              sections_url: window.location.pathname,
            }),
          });
          const state = await response.json();
          if (!response.ok || state.status) {
            rejected = response.status >= 400 && response.status < 500;
            throw new Error('add-failed');
          }
          accepted = true;
          const replacements = pageSections.map(section => {
            const html = state.sections?.[section.section];
            const source = html && new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
            const host = document.getElementById(section.id);
            const target = host?.querySelector(section.selector) || host;
            if (!source || !target) throw new Error('section-unavailable');
            return { target, html: source.innerHTML };
          });
          if (!state.sections?.['cart-drawer'] || !state.sections?.['cart-icon-bubble']) {
            throw new Error('section-unavailable');
          }
          replacements.forEach(({ target, html }) => { target.innerHTML = html; });
          if (drawer) {
            drawer.renderContents(state);
          } else {
            const icon = document.getElementById('cart-icon-bubble');
            const iconHTML = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (icon && iconHTML) icon.innerHTML = iconHTML.innerHTML;
            const otherDrawer = document.querySelector('cart-drawer-items');
            if (otherDrawer) await otherDrawer.onCartUpdate();
          }
          const focusTarget = drawer?.querySelector('#CartDrawer-Checkout') || document.querySelector('#checkout');
          focusTarget?.focus({ preventScroll: true });
        } catch (error) {
          if (accepted) {
            window.location.assign(root + 'cart');
            return;
          }
          status.textContent = rejected ? this.dataset.error : this.dataset.uncertain;
          status.hidden = false;
          this.querySelector('.es-free-shipping__recovery').hidden = false;
          button.disabled = !rejected;
        } finally {
          EsCartAdd.pending = false;
          button.removeAttribute('aria-busy');
          button.textContent = label;
        }
      }
    }
    customElements.define('es-cart-add', EsCartAdd);
  }
  } catch(e) { console.error(e); }
})();

})();
